import React from "react";
import "./NothingToShowBox.scss";

const NothingToShowBox = (props) => {
  return (
    <div className="nothingToShowBox">
      <div className="alertBox">
        <span className="notice">توجه!</span>&nbsp;{props.title}
      </div>
      {props.note1 ||
        (props.note2 && (
          <div className="desc">
            <span className="title">تلاش کنید:</span>
            <span className="note">{props.note1}</span>
            <span className="note">{props.note2}</span>
          </div>
        ))}
    </div>
  );
};

export default React.memo(NothingToShowBox);
